// @flow
export default ({
  authenticatedUser: null,
}: {
  authenticatedUser: ?number,
})
